'use client';

import { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Grid,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  collection,
  addDoc,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

export default function CrearOfertaEmpleo() {
  const [formData, setFormData] = useState({
    titulo: "",
    descripcion: "",
    requisitos: "",
    fechaPublicacion: "",
    sueldo: "",
    ubicacion: "",
    tipoContrato: "",
    jornada: "",
    experiencia: "",
    estudios: "",
    habilidades: "",
    idiomas: "",
    otros: "",
  });

  const [ofertas, setOfertas] = useState([]);

  const tiposContrato = ["Tiempo completo", "Medio tiempo", "Contrato temporal", "Prácticas"];
  const jornadas = ["Diurna", "Nocturna", "Mixta"];
  const experiencias = ["Sin experiencia", "1 año", "2 años", "3 años", "Más de 3 años"];
  const estudios = ["Primaria", "Secundaria", "Bachillerato", "Técnico", "Universitario", "Postgrado"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const ofertasCollection = collection(db, "ofertasEmpleos");
      const docRef = await addDoc(ofertasCollection, formData);

      setOfertas([
        ...ofertas,
        {
          id: docRef.id,
          ...formData,
        },
      ]);

      alert("Oferta de empleo creada exitosamente!");

      setFormData({
        titulo: "",
        descripcion: "",
        requisitos: "",
        fechaPublicacion: "",
        sueldo: "",
        ubicacion: "",
        tipoContrato: "",
        jornada: "",
        experiencia: "",
        estudios: "",
        habilidades: "",
        idiomas: "",
        otros: "",
      });
    } catch (error) {
      console.error("Error al crear la oferta de empleo:", error);
      alert("Ocurrió un error al crear la oferta de empleo.");
    }
  };

  useEffect(() => {
    const fetchOfertas = async () => {
      try {
        const ofertasCollection = collection(db, "ofertasEmpleos");
        const querySnapshot = await getDocs(ofertasCollection);
        const ofertasData = [];
        querySnapshot.forEach((doc) => {
          ofertasData.push({ id: doc.id, ...doc.data() });
        });
        setOfertas(ofertasData);
      } catch (error) {
        console.error("Error al obtener las ofertas de empleo:", error);
      }
    };

    fetchOfertas();
  }, []);

  const handleDeleteOferta = async (ofertaId) => {
    try {
      // Eliminar la oferta de empleo
      const ofertaRef = doc(db, "ofertasEmpleos", ofertaId);
      await deleteDoc(ofertaRef);
      console.log("Oferta de empleo eliminada con ID: ", ofertaId);

      // Actualizar el estado para reflejar la eliminación
      setOfertas(ofertas.filter((oferta) => oferta.id !== ofertaId));

      alert("Oferta de empleo eliminada exitosamente!");
    } catch (error) {
      console.error("Error al eliminar la oferta de empleo:", error);
      alert("Ocurrió un error al eliminar la oferta de empleo.");
    }
  };
  return (
    <Container>
      <Typography variant="h4" align="center" gutterBottom>
        Crear Oferta Laboral
      </Typography>
      <Paper sx={{ padding: 3 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Título"
                variant="outlined"
                fullWidth
                name="titulo"
                value={formData.titulo}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Descripción"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                name="descripcion"
                value={formData.descripcion}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Requisitos"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                name="requisitos"
                value={formData.requisitos}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Fecha de Publicación"
                variant="outlined"
                fullWidth
                type="date"
                name="fechaPublicacion"
                value={formData.fechaPublicacion}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Sueldo"
                variant="outlined"
                fullWidth
                name="sueldo"
                value={formData.sueldo}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Ubicación"
                variant="outlined"
                fullWidth
                name="ubicacion"
                value={formData.ubicacion}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Tipo de Contrato</InputLabel>
                <Select
                  name="tipoContrato"
                  value={formData.tipoContrato}
                  onChange={handleChange}
                  label="Tipo de Contrato"
                  required
                >
                  {tiposContrato.map((tipo) => (
                    <MenuItem key={tipo} value={tipo}>
                      {tipo}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Jornada</InputLabel>
                <Select
                  name="jornada"
                  value={formData.jornada}
                  onChange={handleChange}
                  label="Jornada"
                  required
                >
                  {jornadas.map((jornada) => (
                    <MenuItem key={jornada} value={jornada}>
                      {jornada}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Experiencia</InputLabel>
                <Select
                  name="experiencia"
                  value={formData.experiencia}
                  onChange={handleChange}
                  label="Experiencia"
                  required
                >
                  {experiencias.map((experiencia) => (
                    <MenuItem key={experiencia} value={experiencia}>
                      {experiencia}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Estudios</InputLabel>
                <Select
                  name="estudios"
                  value={formData.estudios}
                  onChange={handleChange}
                  label="Estudios"
                  required
                >
                  {estudios.map((estudio) => (
                    <MenuItem key={estudio} value={estudio}>
                      {estudio}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Habilidades"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                name="habilidades"
                value={formData.habilidades}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Idiomas"
                variant="outlined"
                fullWidth
                name="idiomas"
                value={formData.idiomas}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Otros"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                name="otros"
                value={formData.otros}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary">
                Crear Oferta
              </Button>
            </Grid>
          </Grid>
        </form>

        {/* Lista de ofertas */}
        <Typography variant="h5" sx={{ marginTop: 4, marginBottom: 2 }}>
          Ofertas de Empleo
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Título</TableCell>
                <TableCell>Descripción</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ofertas.map((oferta) => (
                <TableRow key={oferta.id}>
                  <TableCell>{oferta.titulo}</TableCell>
                  <TableCell>{oferta.descripcion}</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => handleDeleteOferta(oferta.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
}